import { useEffect } from 'react'

let appName: string | undefined

export function useDocumentTitle(...parts: (string | null | undefined | false)[]) {
  appName ??= document.title
  const title = [...parts.filter(Boolean), appName].join(' · ')

  useEffect(() => {
    const previous = document.title
    document.title = title
    return () => {
      document.title = previous
    }
  }, [title])
}
